module.exports = __webpack_public_path__ + "img/mbaye_mobility.7dec1fd8.jpeg";